import { defineRule } from 'vee-validate'

export const loadVee = () => {
  defineRule('required', (value: any, params: any) => {
    const opts = Array.isArray(params) ? params[0] : params
    const allowFalse = !(opts && opts.allowFalse === false)
    if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
      return 'This field is required'
    }
    if (value === false && !allowFalse) {
      return 'This field is required'
    }
    return true
  })

  defineRule('email', (value: any) => {
    if (!value) return true
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'This field must be a valid email'
    }
    return true
  })

  defineRule('min', (value: any, [limit]: [number]) => {
    if (!value || !value.length) return true
    if (value.length < limit) {
      return `This field must be at least ${limit} characters`
    }
    return true
  })

  defineRule('max', (value: any, [limit]: [number]) => {
    if (!value || !value.length) return true
    if (value.length > limit) {
      return `This field must not exceed ${limit} characters`
    }
    return true
  })

  defineRule('min_value', (value: any, [limit]: [number]) => {
    if (value === null || value === undefined || value === '') return true
    if (Number(value) < limit) {
      return `This field must be at least ${limit}`
    }
    return true
  })

  defineRule('max_value', (value: any, [limit]: [number]) => {
    if (value === null || value === undefined || value === '') return true
    if (Number(value) > limit) {
      return `This field must not exceed ${limit}`
    }
    return true
  })

  defineRule('between', (value: any, [min, max]: [number, number]) => {
    if (value === null || value === undefined || value === '') return true
    const num = Number(value)
    if (num < min || num > max) {
      return `This field must be between ${min} and ${max}`
    }
    return true
  })

  defineRule('length', (value: any, [len]: [number]) => {
    if (!value) return true
    if (String(value).length !== Number(len)) {
      return `This field must be exactly ${len} characters`
    }
    return true
  })

  defineRule('is', (value: any, [target]: [any]) => {
    if (value !== target) {
      return 'This field must match'
    }
    return true
  })

  defineRule('non_zero', (value: any) => {
    if (value === null || value === undefined || Number.isNaN(Number(value)) || value <= 0) {
      return 'This field must be greater than zero'
    }
    return true
  })

  defineRule('url', (value: any) => {
    if (!value) return true
    if (!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value)) {
      return 'This field must be a valid URL'
    }
    return true
  })

  defineRule('max_length', (value: any, [maxLength]: [number]) => {
    if (value === null || value === undefined) return maxLength >= 0
    if (Array.isArray(value)) return value.length < maxLength
    return String(value).length <= maxLength
  })
}
